import { X } from 'lucide-solid'
import { type JSX, type ParentProps, Show } from 'solid-js'
import { css } from 'styled-system/css'
import { Drawer } from '../ui/drawer'
import { IconButton } from '../ui/icon-button'

export const AppDrawer = (
	props: ParentProps<Drawer.RootProps> & {
		title: string
		trigger?: JSX.Element
		maxWidth?: string
	},
) => {
	return (
		<Drawer.Root
			lazyMount
			{...props}
		>
			<Show when={props.trigger}>
				<Drawer.Trigger>{props.trigger}</Drawer.Trigger>
			</Show>
			<Drawer.Backdrop />
			<Drawer.Positioner
				width="100%"
				maxWidth={props.maxWidth || '600px'}
			>
				<Drawer.Content>
					<Drawer.Header>
						<div
							class={css({
								display: 'grid',
								gridTemplateColumns: '1fr auto',
								justifyContent: 'space-between',
								alignItems: 'center',
							})}
						>
							<Drawer.Title>{props.title}</Drawer.Title>
							<Drawer.CloseTrigger
								asChild={(closeProps: any) => (
									<IconButton
										size="xs"
										variant="subtle"
										colorPalette="accent"
										{...closeProps}
									>
										<X />
									</IconButton>
								)}
							/>
						</div>
					</Drawer.Header>
					<Drawer.Body>
						<Show when={props.open || true}>{props.children}</Show>
					</Drawer.Body>
				</Drawer.Content>
			</Drawer.Positioner>
		</Drawer.Root>
	)
}
